














































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { MensagensDaApiEnum } from '@/types/_'
import { timeout, maskDateTime as formatDateTime } from '@/utils/common'

@Component
export default class ComponentModalCriarEditarEspecialidade extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { form: any }

  tab: string = 'especialidade'
  subEspMode: string = 'CREATE'
  procMode: string = 'CREATE'

  loadingSubmit: boolean = false
  loadingSubEsp: boolean = false
  loadingProc: boolean = false
  loadingDelete: boolean = false

  showDeleteSubEsp: boolean = false
  showDeleteProc: boolean = false
  idDeleteSubEsp: any = ''
  idDeleteProc: any = ''

  formRules: any = {
    valid: true,
    descricao: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get store() { return getModule(FinanceiroStore, this.$store) }

  get modalAberto() { return this.store.modal.criarEditarEspecialidade }
  set modalAberto(value: boolean) { this.store.setModal({ name: 'criarEditarEspecialidade', value }) }

  get headersSubEsp() {
    return [
      { text: 'Descrição', value: 'descricao', align: 'left', sortable: false },
      { text: 'Criado por', value: 'createdByNome', align: 'left', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get headersProc() {
    return [
      { text: 'Subespecialidade', value: 'subEspecialidadeId', align: 'left', sortable: false },
      { text: 'Código do procedimento', value: 'codigoProcedimento', align: 'left', sortable: false },
      { text: 'Criado por', value: 'createdByNome', align: 'left', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get paginasSubEsp() {
    return Math.ceil(this.store.itemsSubEspecialidadeTotal / this.store.qtdPorPagina)
  }

  get paginasProc() {
    return Math.ceil(this.store.itemsEspecialidadeProcedimentoTotal / this.store.qtdPorPagina)
  }

  nomeSubEsp(id: any) {
    if (!id) return '-'
    const sub = this.store.itemsSubEspecialidade.find((s: any) => s.id === id)
    return sub ? sub.descricao : '-'
  }

  maskDateTime(date: any) {
    return date ? formatDateTime(date) : '-'
  }

  async createOrUpdate() {
    if (!this.$refs.form.validate()) return
    this.loadingSubmit = true

    const request = this.mode === 'CREATE'
      ? await this.store.createEspecialidade()
      : await this.store.updateEspecialidade()

    if (request.success) {
      if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
        this.loadingSubmit = false
        return
      }
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Especialidade ${this.mode === 'CREATE' ? 'criada' : 'atualizada'} com sucesso!`,
        icon: 'done',
        color: '#2E7D32',
      })
      this.$emit('update-items-table')
      if (this.mode === 'CREATE') this.modalAberto = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message || `Ocorreu um erro na requisição...`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingSubmit = false
  }

  // --- SubEspecialidades ---
  criarSubEsp() {
    this.subEspMode = 'CREATE'
    this.store.clearItemSubEspecialidade()
    this.store.setItemSubEspecialidade({ especialidadeId: this.store.itemEspecialidade.id })
    this.store.setModal({ name: 'criarEditarSubEspecialidade', value: true })
  }

  async editarSubEsp(item: any) {
    this.subEspMode = 'EDIT'
    this.store.clearItemSubEspecialidade()
    this.store.setOriginalItemSubEspecialidade({ ...item })
    this.store.setItemSubEspecialidade({ ...item })
    this.store.setModal({ name: 'criarEditarSubEspecialidade', value: true })
  }

  setSubEspDelete(id: any) {
    this.idDeleteSubEsp = id
    this.showDeleteSubEsp = true
  }

  async confirmarDeleteSubEsp() {
    this.loadingDelete = true
    const response = await this.store.deleteSubEspecialidade(this.idDeleteSubEsp)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Subespecialidade apagada com sucesso!', icon: 'done', color: '#2E7D32' })
      this.showDeleteSubEsp = false
      await this.reloadSubEsps()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um problema.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDelete = false
  }

  async reloadSubEsps() {
    this.loadingSubEsp = true
    this.store.setFiltroEspecialidadeIdSubEsp(this.store.itemEspecialidade.id)
    await this.store.getAllSubEspecialidade()
    this.loadingSubEsp = false
  }

  async changePageSubEsp(pagina: number) {
    this.store.setItemsSubEspecialidadePagina(pagina)
    await this.reloadSubEsps()
  }

  abrirImportacao() {
    this.store.setModal({ name: 'importarProcedimentos', value: true })
  }

  // --- Procedimentos ---
  async criarProc() {
    this.procMode = 'CREATE'
    this.store.clearItemEspecialidadeProcedimento()
    this.store.setItemEspecialidadeProcedimento({ especialidadeId: this.store.itemEspecialidade.id })
    this.store.setModal({ name: 'criarEditarEspecialidadeProcedimento', value: true })
  }

  async editarProc(item: any) {
    this.procMode = 'EDIT'
    this.store.clearItemEspecialidadeProcedimento()
    this.store.setOriginalItemEspecialidadeProcedimento({ ...item })
    this.store.setItemEspecialidadeProcedimento({ ...item })
    this.store.setModal({ name: 'criarEditarEspecialidadeProcedimento', value: true })
  }

  setProcDelete(id: any) {
    this.idDeleteProc = id
    this.showDeleteProc = true
  }

  async confirmarDeleteProc() {
    this.loadingDelete = true
    const response = await this.store.deleteEspecialidadeProcedimento(this.idDeleteProc)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento apagado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.showDeleteProc = false
      await this.reloadProcs()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um problema.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDelete = false
  }

  async reloadProcs() {
    this.loadingProc = true
    this.store.setFiltroEspecialidadeIdProc(this.store.itemEspecialidade.id)
    await this.store.getAllEspecialidadeProcedimento()
    this.loadingProc = false
  }

  async changePageProc(pagina: number) {
    this.store.setItemsEspecialidadeProcedimentoPagina(pagina)
    await this.reloadProcs()
  }

  @Watch('modalAberto')
  async onChangeModal(value: boolean) {
    if (!value) {
      this.store.clearItemEspecialidade()
      this.store.clearOriginalItemEspecialidade()
      this.$refs.form && this.$refs.form.resetValidation()
      this.tab = 'especialidade'
      return
    }
    if (!this.store.fontePagadoras.length) await this.store.getFontePagadoraAll()
    if (this.mode === 'EDIT') {
      this.store.setItemsSubEspecialidadePagina(1)
      this.store.setItemsEspecialidadeProcedimentoPagina(1)
      await Promise.all([this.reloadSubEsps(), this.reloadProcs()])
    }
  }

  @Watch('tab')
  async onTabChange(value: string) {
    if (value === 'procedimentos') {
      // garante que sub-esps estão carregadas para o modal de procedimento
      this.store.setFiltroEspecialidadeIdSubEsp(this.store.itemEspecialidade.id)
      if (!this.store.itemsSubEspecialidade.length) await this.store.getAllSubEspecialidade()
    }
  }
}
